import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';
import { retrieveData } from '../actions/fetch-data';
import { popupOpen } from '../actions/pop-ups';
import Header from '../components/headers/header';
import Pagination from '../components/search/search-pagination';
import SortButtons from '../components/tables/sort-buttons';
import UserFilters from '../components/user/user-filters';

import { GET_USERS_DATA, VIEW_USER_POPUP, DELETE_USER_POPUP } from '../constants/constants';
import { USERS } from '../constants/endpoints';

class UsersPage extends React.Component {
    componentDidMount() {
        this.fetchUsers();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.fetchUsers();
        }
    }

    fetchUsers() {
        const { query } = this.props.location;
        const searchParams = queryString.stringify(query);
        const url = `${USERS}?${searchParams}`;

        this.props.retrieveData(url, GET_USERS_DATA);
    }

    renderUsers() {
        const { users, asyncAction } = this.props.state;

        if (!users.loaded || asyncAction.requestActive) {
            return (
            <tr>
                <td colSpan="8" className="tac">
                    <img src={require("../../images/loading-c.gif")} />
                </td>
            </tr>
            );
        }
        if (users.data.length === 0) {
            return (
            <tr>
                <td colSpan="8" className="tac">
                    No users match these filters.
                </td>
            </tr>
            );
        }
        return this.props.state.users.data.map((user, index) => {
            let { confirmed, abandoned } = user;
            const confirmedClasses = classnames({
                'confirmed-account': confirmed,
                'unconfirmed-account': !confirmed,
                'abandoned-account': abandoned,
                'fa': true,
                'fa-check-circle': confirmed,
                'fa-times-circle': !confirmed && !abandoned,
                'fa-user-times': abandoned,
                'c-success': confirmed,
                'c-warning': !confirmed && !abandoned,
                'c-error': abandoned,
            });
            const freeTrialClasses = classnames({
                'confirmed-account': true,
                'fa': true,
                'fa-check-circle': !user.free_trial_expired,
                'fa-times-circle': user.free_trial_expired,
                'c-success': !user.free_trial_expired,
                'c-error': user.free_trial_expired,
            });
            return (
                <tr key={index}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td
                        title={
                            user.abandoned
                                ? 'User has not confirmed their account within 3 months and could be deleted.'
                                : null
                        }
                    >
                        <i className={confirmedClasses} aria-hidden="true"></i>
                    </td>
                    <td>
                        {user.account_type == 'Starter' ? <i className={freeTrialClasses} aria-hidden="true"></i> : '-'}
                    </td>
                    <td>{user.account_type}</td>
                    <td>{user.subscription ? user.subscription.status : '-'}</td>
                    <td>{moment(user.created_at).format('MMMM Do YYYY')}</td>
                    <td>
                        <span className="tag-item__badge" onClick={() => this.props.popupOpen(VIEW_USER_POPUP, user)}>
                            View
                        </span>
                        <span
                            className="tag-item__badge tag-item__badge--delete"
                            onClick={() => this.props.popupOpen(DELETE_USER_POPUP, user)}
                        >
                            Delete
                        </span>
                    </td>
                </tr>
            );
        });
    }

    render() {
        return (
            <div>
                <Header title="Users" subtitle="Manage users" />
                <div className="content">
                    <UserFilters
                        location={this.props.location}
                        plans={this.props.state.users.plans}
                        subscriptionStatuses={this.props.state.users.subscriptionStatuses}
                    />
                    <table width="100%" className="pure-table pure-table-horizontal pure-table-striped user-table">
                        <thead>
                            <tr>
                                <th>
                                    Name <SortButtons searchKey="name" />
                                </th>
                                <th>
                                    Email <SortButtons searchKey="email" />
                                </th>
                                <th>Confirmed?</th>
                                <th>Free Trial Active?</th>
                                <th>
                                    Account Type <SortButtons searchKey="account_type" />
                                </th>
                                <th>
                                    Subscription Status <SortButtons searchKey="subscription_status" />
                                </th>
                                <th>
                                    Date Joined <SortButtons searchKey="created_at" />
                                </th>
                                <th>Delete</th>
                            </tr>
                        </thead>

                        <tbody>{this.renderUsers()}</tbody>
                    </table>

                    {this.props.state.asyncAction.requestActive ? null : (
                        <Pagination totalPages={this.props.state.users.totalPages} location={this.props.location} />
                    )}
                </div>
            </div>
        );
    }
}

export default connect(nextState => ({ state: nextState }), { retrieveData, popupOpen })(UsersPage);
